import React from 'react';
import { useLocation } from 'react-router-dom';
import { getNavIconClass, resolveNavThemeForPath } from '../../../navigation/clinicNavConfig';

function SubHeader({
    title,
    description,
    children,
    containerClass = 'container-xxl',
    icon,
    iconTheme,
}) {
    const location = useLocation();
    const resolvedTheme = iconTheme || resolveNavThemeForPath(location.pathname);
    const iconClass = getNavIconClass(resolvedTheme);

    return (
        <div className="py-3 py-lg-4 border-bottom bg-light">
            <div
                className={`${containerClass} d-flex justify-content-between flex-md-row flex-column align-items-md-center gap-3`}
            >
                <div className="d-flex align-items-center flex-wrap me-3">
                    {icon && (
                        <span
                            className={`subheader-icon-badge ecx-nav-icon ${iconClass} me-3 flex-shrink-0`}
                            aria-hidden="true"
                        >
                            <i className={`bi ${icon}`} />
                        </span>
                    )}
                    <div className="d-flex flex-column justify-content-center">
                        <h1 className="h3 text-dark fw-normal my-0">{title && title}</h1>
                        {description && (
                            <span className="text-muted fw-normal small my-0 pt-1">
                                {description}
                            </span>
                        )}
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
}

export default SubHeader;
